import { render } from "./default.vue?vue&type=template&id=f8b3a7c0"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/inspection_reports/form-elements/default.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f8b3a7c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f8b3a7c0', __exports__)) {
    console.log('reload')
    api.reload('f8b3a7c0', __exports__)
  }
  
  module.hot.accept("./default.vue?vue&type=template&id=f8b3a7c0", () => {
    console.log('re-render')
    api.rerender('f8b3a7c0', render)
  })

}


export default __exports__